import { useState } from 'react'
import { useSearchParams } from 'react-router-dom'

const useWeeklyCalendarTabs = () => {
  const [searchParams] = useSearchParams()
  const initialTab = searchParams.get('tab') === 'list' ? 'list' : 'calendar'
  const [activeTab, setActiveTab] = useState(initialTab)

  return { activeTab, setActiveTab }
}

export default useWeeklyCalendarTabs
